import React from "react";
import { useWeekMenu } from "./useWeekMenu";
import styled from "styled-components";
import useMenuTitle from "../../hooks/useMenuTitle";
import { Button } from "react-day-picker";

const Image = styled.img`
  height: 800px;
`;

const StyledImage = styled.img`
  height: ${(props) => props.$height || "800px"};
  border-radius: 25px;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
`;

export default function WeekMenu({ weekNumber, height }) {
  useMenuTitle("Lunch Menu");
  const { data: menuData, isLoading, isError, error } = useWeekMenu(weekNumber);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  console.log("WeekMenu", menuData.image, menuData.name);
  return (
    <>
      <div>
        <StyledImage
          $height={height}
          src={menuData.image}
          alt={menuData.name}
        />
        <h4>{menuData.name}</h4>
      </div>
    </>
  );
}
